<template>
    <div class="form">
        <!-- Equipment -->
        <div class="form__section">
            <div class="form__title">Ausstattung</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :showInRows="true"
                        :values="data.facility" 
                         :tracking-data-category="'Service Station'"
                        :options="facilityOptions"
                        @change="fieldChangeHandler($event, 'facility')"
                    />
                </div>
            </div>
        </div>
        <!-- Other options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :showInRows="true"
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import messageBoxBlueprint from '@/mixins/message-box-blueprint.js';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'

export default {
    components: {
        SmrChoiceGroup,
    },
    mixins: [
        settingsTabBlueprint,
        messageBoxBlueprint
    ],
    data() {
        return {
            data: {},
            facilityOptions: [
                // {value: 'terrace', label: 'Terrasse' },
                {value: 'playground', label: 'Kinderspielecke /-platz', trackingLabel: 'Kids Playground'},
                {value: 'changingTable', label: 'Wickelraum', trackingLabel: 'Kids Changing Room'},
            ],
        }
    },
    computed: {
        ...mapGetters(['user']),
        otherOptions() {
            return [
                {value: 'openNextHour', label: 'In der nächsten Stunde geöffnet' },
                {value: 'openAllDay', label: '24 h geöffnet' },
                {value: 'oeamtcPartner', label: 'Nur Vorteilspartner' },
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true},
                {value: 'accessible', label: 'Nur Barrierefrei' },
            ]
        }
    }
}
</script>
